export default "__VITE_ASSET__CI7bDqc9__"